module.exports = __webpack_public_path__ + "static/media/FuelBoss_icon.bac85ffc.png";